<template>
  <div>
    <div class="card-list">
      <el-row class="top-column">
        <el-col :span="1">
          <div class="textCenter">
            <el-checkbox
              @change="handleAllChange"
              :indeterminate="isIndeterminate"
              v-model="checkAll"
            ></el-checkbox
          ></div>
        </el-col>
        <el-col :span="3"><div class="textCenter">订单编号</div></el-col>
        <el-col :span="2"><div class="textCenter">项目名称</div></el-col>
        <el-col :span="2"><div class="textCenter">客户名称</div></el-col>
        <el-col :span="13"><div class="textCenter">订单进度</div></el-col>
        <!-- <el-col :span="4"><div class="textCenter">订单处理时间信息</div></el-col> -->
        <el-col :span="3"><div class="textCenter">操作</div></el-col>
      </el-row>
      <div v-for="(item, index) in cardData" :key="index">
        <el-row :class="item.isOverdue ? 'list-overdueItem' : 'list-item'">
          <el-col :span="1" style="height: 100%" class="allCenter"
            ><div
              ><el-checkbox
                @change="handleChange(item, index)"
                v-model="item.relation"
              ></el-checkbox></div
          ></el-col>
          <!-- 订单编号 -->
          <el-col :span="3" class="order-no" style="height: 100%">
            <div>{{ item.orderCode }}</div>
            <div>订单状态: {{ item.orderStatusName }}</div>
            <div class="over-due" v-show="item.isOverdue">已超期</div>
          </el-col>
          <!-- 项目名称 -->
          <el-col :span="2" class="order-codes" style="height: 100%">
            <div>{{ item.projectName }}</div>
          </el-col>
          <!-- 客户名称 -->
          <el-col :span="2" class="order-codes" style="height: 100%">
            <div>{{ item.customerName }}</div>
          </el-col>
          <!-- 订单进度 -->
          <el-col
            :span="13"
            :class="item.isOverdue ? 'order-overProgress' : 'order-progress'"
            style="height: 100%"
          >
            <OrderProgress :currStatus="item.orderStatus" :listData="item.listArr" />
          </el-col>
          <!-- 订单处理时间信息 -->
          <!-- <el-col :span="4" class="order-info" style="height: 100%">
            <div>接单完成时间: {{ item.a }}</div>
            <div>公路装卸开始时间: {{ item.a }}</div>
            <div>公路装卸完成时间: {{ item.a }}</div>
            <div>公路运输开始时间: {{ item.a }}</div>
            <div>公路运输完成时间: {{ item.a }}</div>
          </el-col> -->
          <!-- 操作 -->
          <el-col :span="3" class="order-operate" style="height: 100%">
            <div @click="goDetail(item)">单据详情</div>
            <div
              @click="handleEdit(item)"
              v-if="
                item.orderStatus == 'draft' ||
                item.orderStatus == 'part_issued' ||
                item.orderStatus == 'issued' ||
                item.orderStatus == 'ongoing' ||
                item.orderStatus == 'expired'
              "
              >修改编辑</div
            >
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="pagination" v-if="page.total > 0">
      <div class="left"
        >显示第 {{ (page.pageNum - 1) * page.pageSize + 1 }} 条到
        {{
          (page.pageNum - 1) * page.pageSize + page.pageSize > page.total
            ? page.total
            : (page.pageNum - 1) * page.pageSize + page.pageSize
        }}
        条记录，共 {{ page.total }} 条记录</div
      >
      <el-pagination
        v-if="page.total > 0"
        class="right"
        ref="page"
        background
        @size-change="handleSizeChange"
        @current-change="handlePagination"
        :page-count="page.pages"
        :current-page="page.pageNum || 1"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.total"
        layout="sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
  import OrderProgress from './orderProgress';
  import XEUtils from 'xe-utils';
  import orderMixin from '@/pages/intermodality/order/orderMixin';
  import { instructStatusList } from '../data';
  export default {
    name: 'cardList',
    mixins: [orderMixin],
    props: ['cardTableData'],
    components: {
      OrderProgress,
    },
    watch: {
      cardTableData(newVal) {
        this.cardTableData = newVal;
        this.dealCardData();
      },
    },
    data() {
      return {
        cardData: [],
        page: {
          pages: 1, //总共多少页
          pageNum: 1, //第几页
          pageSize: 10, //一页多少条数据
          total: 0, //总共多少条
        },
        selectedData: [],
        selectedId: [],
        serviceList: [],
        instructStatusList,
        isIndeterminate: false,
        checkAll: false,
        checkedCard: [],
      };
    },
    created() {
      this.getServiceList();
    },
    methods: {
      dealCardData() {
        this.cardTableData.forEach((card) => {
          card.isOverdue =
            card.orderStatus === 'completed' || card.orderStatus === 'invalid'
              ? false
              : this.dealIsOverdue([...card.ordinaryTruckInstructs, ...card.transportInstructs]);
          card.listArr = this.getArr(card);
        });
        this.cardData = this.cardTableData;
        console.log(this.cardData, 'cardDatacardData');
      },
      getArr(row) {
        const arr = [...row.ordinaryTruckInstructs, ...row.transportInstructs];
        const targetArr = [];
        if (arr.length > 0) {
          arr.forEach((item) => {
            targetArr.push({
              serviceName: this.transferSelect(item.serviceType, this.serviceList),
              serviceStatus: this.transferSelect(item.instructStatus, this.instructStatusList),
              startTime: item.instructIssueDate,
              completeTime: item.businessComplatedDate,
              isComplete: item.businessComplatedDate ? true : false,
            });
          });
        }
        return targetArr;
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      dealIsOverdue(list) {
        let isOverdueFlag = false;
        if (list.length === 0) {
          isOverdueFlag = false;
        } else {
          list.forEach((item) => {
            if (new Date() > new Date(item.planDeliveryDate)) {
              isOverdueFlag = true;
            }
          });
        }
        return isOverdueFlag;
      },

      goDetail(row) {
        let path = {
          path: '/intermodality/orderPage',
          name: 'orderPage',
          meta: {
            keepAlive: true,
            title: '订单详情',
          },
          query: {
            id: row.id,
            turnType: '3',
            orderCode: row.orderCode,
            orderCurrStatus: row.orderStatus,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handleEdit(row) {
        let path = {
          path: '/intermodality/orderPage',
          name: 'orderPage',
          meta: {
            keepAlive: true,
            title: '订单详情',
          },
          query: {
            id: row.id,
            orderCode: row.orderCode,
            turnType: '1',
            orderCurrStatus: row.orderStatus,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      handleAllChange(val) {
        console.log(val, 'handleAllChange');
        if (this.checkAll) {
          this.cardData.forEach((item) => {
            item.relation = true;
          });
        } else {
          this.cardData.forEach((item) => {
            item.relation = false;
          });
        }
        let selectedCard = [];
        this.cardData.forEach((card) => {
          if (card.relation) {
            selectedCard.push(card);
          }
        });
        console.log(selectedCard, 'selectedCard');
        this.$emit('cardClick', selectedCard);
      },
      handleChange(val, index) {
        console.log(val, val.id, val.relation, index, '1111');
        this.$forceUpdate();
        let selectedCard = [];
        this.cardData.forEach((card) => {
          if (card.relation) {
            selectedCard.push(card);
          }
        });
        console.log(selectedCard, 'selectedCard');
        this.$emit('cardClick', selectedCard);
      },
      //设置总条数
      setPageTotal(val) {
        this.page.total = val;
      },
      //设置页数为第一页
      setPageNum(val) {
        this.page.pageNum = val;
      },
      //设置每页显示10条
      setPageSize(val) {
        this.page.pageSize = val;
      },
      //抛出选择每页条数事件
      handleSizeChange(val) {
        //每次重新选择每页条数，都需要从第一页开始查询
        this.page.pageNum = 1;
        this.page.pageSize = val;
        this.$emit('handleSizeChange', val);
      },
      //抛出当前页数跳转事件
      handlePagination(val) {
        this.page.pageNum = val;
        this.$emit('handleCurrentChange', val);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .card-list {
    height: 464px;
    overflow-y: auto;
    .top-column {
      height: 32px;
      line-height: 32px;
      background-color: #fff;
      border-radius: 4px;
    }
  }
  .textCenter {
    text-align: center;
  }
  .list-overdueItem {
    height: 130px;
    width: 100%;
    // background-color: rgb(233, 197, 36);
    background-color: rgb(233 221 163);
    margin-top: 10px;
    border-radius: 4px;
  }
  .list-item {
    height: 130px;
    width: 100%;
    background-color: rgba(255, 255, 255, 1);
    margin-top: 10px;
    border-radius: 4px;
  }
  .order-no {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    // background-color: #c1c1c1;
    .over-due {
      color: red;
    }
  }
  .order-codes {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    // background-color: #c1c1c1;
  }
  .order-info {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
  }
  .order-overProgress {
    // background-color: rgb(233, 197, 36);
    background-color: rgb(233 221 163);
    overflow-x: auto;
  }
  .order-progress {
    // background-color: #fff;
    overflow-x: auto;
  }
  .order-operate {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    div {
      cursor: pointer;
      color: #1890ff;
    }
  }
  .allCenter {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pagination {
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .el-pagination {
      display: inline-block;
    }
    .left {
      color: #999999;
      font-size: 12px;
    }
    .right {
      ::v-deep .active:hover {
        color: #ffffff !important;
      }
    }
  }
  .el-pagination {
    text-align: right;
    padding-top: 10px;
    margin-bottom: 8px;
  }
</style>
